import React, { useContext, useEffect, useRef, useState } from 'react'
import QueryContext from '../utils/QueryContext'


const Search = ({ onSearchChange, updateQueryParams }) => {
    const queryParams = useContext(QueryContext);
    const [innerSearch, setInnerSearch] = useState(queryParams.search);
    const debounceRef = useRef(null);

    useEffect(() => {
        setInnerSearch(queryParams.search);
    }, [queryParams.search])

    const onChange = (event) => {
        const value = event.currentTarget.value;
        setInnerSearch(value);

        clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
            updateQueryParams({ search: value, page: 1 });
        }, 400);
    };

    return (
        <div className="flex-grow">
        <input
            type="text"
            name="search"
            id="search"
            value={innerSearch}
            className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md h-full"
            placeholder="Enter search..."
            onChange={onChange}
        />
        </div>
    )
}

export default Search
